import { jsx } from 'react/jsx-runtime';
import { format } from 'url';
import { forwardRef, Children, cloneElement } from 'react';
import { useLinkClickHandler, Link } from 'react-router-dom';
import { dispatchLinkClickedEvent } from '../event.mjs';
import getPrevLocation from '../utils/getPrevLocation.mjs';
import isNextAppUrl from '../utils/isNextAppUrl.mjs';
import useFlexLocation from '../hooks/useFlexLocation.mjs';

function LinkInner({
  href,
  passHref = false,
  children,
  shallow,
  onClick,
  state,
  ...linkProps
}, ref) {
  const location = useFlexLocation();
  const urlToNavigate = typeof href === "string" ? href : format(href);
  const handleClickLink = (e) => {
    onClick?.(e);
    if (!e.defaultPrevented) {
      dispatchLinkClickedEvent(urlToNavigate);
    }
  };
  const stateWithPrevLocation = {
    ...state !== void 0 ? state : {},
    prevLocation: getPrevLocation({
      replace: linkProps.replace ?? false,
      location
    })
  };
  const linkClickHandler = useLinkClickHandler(urlToNavigate, {
    ...linkProps,
    state: stateWithPrevLocation
  });
  const isTargetToNextApp = isNextAppUrl(urlToNavigate);
  if (!passHref && isTargetToNextApp) {
    return /* @__PURE__ */ jsx("a", { ref, href: urlToNavigate, children });
  }
  if (!passHref && !isTargetToNextApp) {
    return /* @__PURE__ */ jsx(
      Link,
      {
        ref,
        to: urlToNavigate,
        onClick: handleClickLink,
        ...linkProps,
        state: stateWithPrevLocation,
        children
      }
    );
  }
  const child = Children.only(children);
  if (passHref && !isTargetToNextApp) {
    const handleChildrenClick = (event) => {
      handleClickLink(event);
      if (child.props?.onClick !== void 0) {
        child.props.onClick(event);
      }
      if (!event.defaultPrevented && urlToNavigate.startsWith("/")) {
        linkClickHandler(event);
      }
    };
    return cloneElement(child, {
      ref,
      href: urlToNavigate,
      onClick: handleChildrenClick
    });
  }
  if (passHref && isTargetToNextApp) {
    return cloneElement(child, {
      ref,
      href: urlToNavigate,
      onClick: handleClickLink
    });
  }
  return /* @__PURE__ */ jsx("a", { ref, href: urlToNavigate, children });
}
const PodoLink = forwardRef(LinkInner);

export { PodoLink };
//# sourceMappingURL=PodoLink.mjs.map
